var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "block",
    height: 798,
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeMiterlimit: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m299-81h-442l260 3z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444 876-176-4-200 4z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1065-81h-298l104 2z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1080 858-177-4-182 22z",
    fill: "#b40b6e",
    stroke: "#b40b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1256 852-115 1-61 5z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1437-81h-245l119 1z",
    fill: "#ff256f",
    stroke: "#ff256f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1542 876-286-24-176 6z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1542 876-462-18-359 18z",
    fill: "#87036d",
    stroke: "#87036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1575 266-11 28 10 15z",
    fill: "#8f056e",
    stroke: "#8f056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1576 73-137-2 15 115z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1577 826-125-111-39 84z",
    fill: "#af0a6e",
    stroke: "#af0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 374-24-33 22 49z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 374-11-65-13 32z",
    fill: "#ad0a6e",
    stroke: "#ad0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 374-10-108-1 43z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 557-15-81-96 123z",
    fill: "#b00a6e",
    stroke: "#b00a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585-9-88 23 79 59z",
    fill: "#be0c6e",
    stroke: "#be0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585-9v-17l-55-30z",
    fill: "#98066e",
    stroke: "#98066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585-9-55-47-33 70z",
    fill: "#b40b6e",
    stroke: "#b40b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 850-8-24-28 49z",
    fill: "#b90c6e",
    stroke: "#b90c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 583-111 16-27 53z",
    fill: "#ff1b6f",
    stroke: "#ff1b6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 583-138 69 5 63z",
    fill: "#ff226f",
    stroke: "#ff226f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 583-133 132 125 111z",
    fill: "#ff186f",
    stroke: "#ff186f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 583v-26l-111 42z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 583-8 243 8 24z",
    fill: "#ff1a6f",
    stroke: "#ff1a6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 195-103 56 93 15z",
    fill: "#a9096e",
    stroke: "#a9096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 195-131-9 28 65z",
    fill: "#8a046d",
    stroke: "#8a046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 195-9-122-122 113z",
    fill: "#9f076e",
    stroke: "#9f076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 195-10 71 10 108z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 195v-204l-9 82z",
    fill: "#ae0a6e",
    stroke: "#ae0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 876-36-1-7 1z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 876v-26l-36 25z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 398-120 34 105 44z",
    fill: "#b20a6e",
    stroke: "#b20a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 398-2-8-72-33z",
    fill: "#ff226f",
    stroke: "#ff226f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 398-74-41-46 75z",
    fill: "#a7096e",
    stroke: "#a7096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 398v-24l-2 16z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585 398-15 78 15 81z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585-81h-148l93 25z",
    fill: "#98066e",
    stroke: "#98066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1585-81-55 25 55 30z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1583 390-22-49-50 16z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1542 876-129-77-157 53z",
    fill: "#e0126e",
    stroke: "#e0126e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1570 476-105-44 9 167z",
    fill: "#aa096e",
    stroke: "#aa096e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#86036d",
    stroke: "#86036d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1576 73-79-59-58 57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1577 826-164-27 129 77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1577 826-35 50 7-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1575 266-93-15 82 43z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1574 309-10-15-3 47z",
    fill: "#b50b6e",
    stroke: "#b50b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1474 599-9-167-65 94z",
    fill: "#af0a6e",
    stroke: "#af0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1564 294-53 63 50-16z",
    fill: "#89036d",
    stroke: "#89036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1564 294-92 23 39 40z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1564 294-82-43-10 66z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1474 599-74-73 11 34z",
    fill: "#cf0f6e",
    stroke: "#cf0f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1474 599-19 17-8 36z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1497 14-60-95-6 80z",
    fill: "#af0a6e",
    stroke: "#af0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1530-56-93-25 60 95z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1413 799-73-1-84 54z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1482 251-24 58 14 8z",
    fill: "#a5086e",
    stroke: "#a5086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1511 357-39-40-55 38z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1511 357-94-2 48 77z",
    fill: "#97066e",
    stroke: "#97066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1497 14-66-15 8 72z",
    fill: "#ac096e",
    stroke: "#ac096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1437-81-23 68 17 12z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1465 432-93 23 28 71z",
    fill: "#a9096e",
    stroke: "#a9096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1472 317-14-8-41 46z",
    fill: "#ff1d6f",
    stroke: "#ff1d6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1482 251-116 64 92-6z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1482 251-28-65-88 129z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1474 599-63-39 44 56z",
    fill: "#a1086e",
    stroke: "#a1086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1455 616-44-56-8 15z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1437-81-41 26 18 42z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1465 432-48-77-45 100z",
    fill: "#9f076e",
    stroke: "#9f076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1454 186-15-115-189 19z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1458 309-92 6 51 40z",
    fill: "#ff176f",
    stroke: "#ff176f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1437-81-126 1 85 25z",
    fill: "#8f056e",
    stroke: "#8f056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1452 715-5-63-100-5z",
    fill: "#f3156e",
    stroke: "#f3156e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1455 616-52-41 44 77z",
    fill: "#ff1a6f",
    stroke: "#ff1a6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1452 715-112 83 73 1z",
    fill: "#bc0c6e",
    stroke: "#bc0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1454 186-238 52 150 77z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1454 186-204-96-34 148z",
    fill: "#a3086e",
    stroke: "#a3086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1447 652-44-77-37 11z",
    fill: "#a8096e",
    stroke: "#a8096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1447 652-81-66-19 61z",
    fill: "#bf0d6e",
    stroke: "#bf0d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1452 715-105-68-7 151z",
    fill: "#d4106e",
    stroke: "#d4106e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1439 71-8-72-17-12z",
    fill: "#a5086e",
    stroke: "#a5086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1347 647-60 58 53 93z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1439 71-25-84-164 103z",
    fill: "#a9096e",
    stroke: "#a9096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311-80-82 141 21 29z",
    fill: "#c40d6e",
    stroke: "#c40d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1372 455-6-140-89 65z",
    fill: "#8e046e",
    stroke: "#8e046e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1372 455-95-75 34 69z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1414-13-103-67-61 170z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1417 355-51-40 6 140z",
    fill: "#c20d6e",
    stroke: "#c20d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1414-13-18-42-85-25z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1403 575-3-49-34 60z",
    fill: "#bb0c6e",
    stroke: "#bb0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1411 560-11-34 3 49z",
    fill: "#e6136e",
    stroke: "#e6136e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400 526-28-71-61-6z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400 526-89-77 55 137z",
    fill: "#cb0f6e",
    stroke: "#cb0f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1366 315-150-77 1 53z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1366 586-55-137-156 47z",
    fill: "#ab096e",
    stroke: "#ab096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1366 586-211-90 95 183z",
    fill: "#bb0c6e",
    stroke: "#bb0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1366 315-149-24 60 89z",
    fill: "#99066e",
    stroke: "#99066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1366 586-116 93 97-32z",
    fill: "#c40e6e",
    stroke: "#c40e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311-80-125 59 43 82z",
    fill: "#a7096e",
    stroke: "#a7096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1340 798-67-5-17 59z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1340 798-53-93-14 88z",
    fill: "#ba0c6e",
    stroke: "#ba0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1347 647-97 32 37 26z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311-80-121 41-4 18z",
    fill: "#ff206f",
    stroke: "#ff206f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250 679-95-183-43 84z",
    fill: "#b90c6e",
    stroke: "#b90c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250 90-66 117 32 31z",
    fill: "#bd0c6e",
    stroke: "#bd0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311-80-119-1-2 42z",
    fill: "#c60e6e",
    stroke: "#c60e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311 449-34-69-117 22z",
    fill: "#c00d6e",
    stroke: "#c00d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1311 449-151-47-5 94z",
    fill: "#bf0d6e",
    stroke: "#bf0d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1155 496-24 22-19 62z",
    fill: "#f8166f",
    stroke: "#f8166f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250 679-138-99 74 112z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250 90-84 80 18 37z",
    fill: "#95066e",
    stroke: "#95066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1277 380-60-89-28 65z",
    fill: "#b60b6e",
    stroke: "#b60b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1287 705-74 9 60 79z",
    fill: "#94056e",
    stroke: "#94056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1287 705-37-26-37 35z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1273 793-60-79-38 44z",
    fill: "#8a046d",
    stroke: "#8a046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1277 380-88-24-29 46z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229 61-43-82-8 48z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1273 793-98-35 81 94z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250 90-76-17-8 97z",
    fill: "#a4086e",
    stroke: "#a4086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1256 852-81-94-34 95z",
    fill: "#9f076e",
    stroke: "#9f076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250 679-64 13 27 22z",
    fill: "#a7096e",
    stroke: "#a7096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250 90-21-29-55 12z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229 61-51-34-6 28z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229 61-57-6 2 18z",
    fill: "#ff1c6f",
    stroke: "#ff1c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1216 238-32-31-49 76z",
    fill: "#d6106e",
    stroke: "#d6106e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1217 291-1-53-81 45z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1217 291-82-8 54 73z",
    fill: "#bd0c6e",
    stroke: "#bd0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1186 692-74-112 21 122z",
    fill: "#8d046d",
    stroke: "#8d046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1213 714-27-22-34 21z",
    fill: "#ae0a6e",
    stroke: "#ae0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1213 714-61-1 23 45z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160 402-50 61 45 33z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1174 73-50 8 42 89z",
    fill: "#b90c6e",
    stroke: "#b90c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1189 356-54-73-13 15z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1190-39-11 10 7 8z",
    fill: "#f5166e",
    stroke: "#f5166e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1192-81-13 52 11-10z",
    fill: "#f9166f",
    stroke: "#f9166f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1192-81-58 53 45-1z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1192-81h-127l69 53z",
    fill: "#8b046d",
    stroke: "#8b046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1175 758-98 30 64 65z",
    fill: "#a8096e",
    stroke: "#a8096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1179-29-45 1 44 55z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1186-21-7-8-1 56z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1189 356-67-58 38 104z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1186 692-53 10 19 11z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1184 207-18-37-78-13z",
    fill: "#ce0f6e",
    stroke: "#ce0f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1184 207-96-50 47 126z",
    fill: "#8b046d",
    stroke: "#8b046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160 402-38-104-28 6z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1166 170-42-89-36 76z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1133 702-21-122-45 102z",
    fill: "#ae0a6e",
    stroke: "#ae0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160 402-66-98-27 85z",
    fill: "#bb0c6e",
    stroke: "#bb0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1178 27-54 54 48-26z",
    fill: "#d2106e",
    stroke: "#d2106e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1178 27-44-55-10 109z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1175 758-23-45-75 75z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1174 73-2-18-48 26z",
    fill: "#d6106e",
    stroke: "#d6106e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1152 713-19-11-56 86z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160 402-93-13 43 74z",
    fill: "#ba0c6e",
    stroke: "#ba0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1110 463-43-74-7 21z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1131 518-39 36 20 26z",
    fill: "#a2086e",
    stroke: "#a2086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1135 283-82-118 41 139z",
    fill: "#91056e",
    stroke: "#91056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1135 283-47-126-35 8z",
    fill: "#a2086e",
    stroke: "#a2086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1155 496-45-33 21 55z",
    fill: "#eb146e",
    stroke: "#eb146e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1112 580-71 48 26 54z",
    fill: "#c70e6e",
    stroke: "#c70e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1141 853-64-65 3 70z",
    fill: "#ab096e",
    stroke: "#ab096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1124 81-84-147-48 144z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1133 702-66-20 10 106z",
    fill: "#be0c6e",
    stroke: "#be0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134-28-94-38 84 147z",
    fill: "#96066e",
    stroke: "#96066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1131 518-21-55-41 39z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1135 283-41 21 28-6z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134-28-69-53-25 15z",
    fill: "#b70b6e",
    stroke: "#b70b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1094 304-35 10 8 75z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1094 304-41-139 6 149z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1131 518-62-16 23 52z",
    fill: "#c40d6e",
    stroke: "#c40d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1065-81-194 2 169 13z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1077 788-10-106-26 11z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1124 81-105 56 69 20z",
    fill: "#c30d6e",
    stroke: "#c30d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1124 81-132-3 27 59z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1112 580-20-26-51 74z",
    fill: "#c50e6e",
    stroke: "#c50e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1110 463-50-53 9 92z",
    fill: "#c00d6e",
    stroke: "#c00d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059 314-6-149-94 119z",
    fill: "#a1086e",
    stroke: "#a1086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069 502-9-92-34 8z",
    fill: "#d7116e",
    stroke: "#d7116e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1080 858-107-47-70 43z",
    fill: "#98066e",
    stroke: "#98066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088 157-69-20 34 28z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1092 554-109 11 58 63z",
    fill: "#9f076e",
    stroke: "#9f076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m903 854-54-8-128 30z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041 628-58-63 2 25z",
    fill: "#f6166e",
    stroke: "#f6166e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1092 554-23-52-86 63z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041 628-56-38 17 25z",
    fill: "#a4086e",
    stroke: "#a4086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1080 858-3-70-104 23z",
    fill: "#8b046d",
    stroke: "#8b046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069 502-43-84-37 63z",
    fill: "#9a066e",
    stroke: "#9a066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1077 788-36-95-68 118z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1067 389-8-75-33 104z",
    fill: "#c30d6e",
    stroke: "#c30d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1067 682-26-54v65z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069 502-80-21-6 84z",
    fill: "#8e046e",
    stroke: "#8e046e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059 314-100-30 67 134z",
    fill: "#9b076e",
    stroke: "#9b076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1067 389-41 29 34-8z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1040-66-103 132 55 12z",
    fill: "#ac096e",
    stroke: "#ac096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1053 165-34-28-60 147z",
    fill: "#a5086e",
    stroke: "#a5086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041 693-70-31 2 149z",
    fill: "#bc0c6e",
    stroke: "#bc0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041 628-70 34 70 31z",
    fill: "#87036d",
    stroke: "#87036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m973 811-2-149-67 36z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1019 137-55-27-5 174z",
    fill: "#98066e",
    stroke: "#98066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1026 418-67-134-62 89z",
    fill: "#90056e",
    stroke: "#90056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1040-66-169-13 66 145z",
    fill: "#92056e",
    stroke: "#92056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041 628-39-13-31 47z",
    fill: "#97066e",
    stroke: "#97066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1019 137-27-59-28 32z",
    fill: "#ba0c6e",
    stroke: "#ba0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1026 418-129-45 92 108z",
    fill: "#a2086e",
    stroke: "#a2086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m964 110-109 41 104 133z",
    fill: "#b60b6e",
    stroke: "#b60b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m989 481-46 56 40 28z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m973 811-52 13-18 30z",
    fill: "#c50e6e",
    stroke: "#c50e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m973 811-92-44 44 49z",
    fill: "#bf0d6e",
    stroke: "#bf0d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m973 811-69-113-23 69z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1002 615-17-25-14 72z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m983 565-40-28 12 28z",
    fill: "#c20d6e",
    stroke: "#c20d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m985 590-30-25 16 97z",
    fill: "#b20a6e",
    stroke: "#b20a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m989 481-92-108-51 29z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m992 78-55-12 27 44z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959 284-104-133-14 122z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m985 590-2-25h-28z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m989 481-143-79 97 135z",
    fill: "#96066e",
    stroke: "#96066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m943 537-97-135 15 136z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m861 538-15-136-30 59z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m937 66-66-145-40 117z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m971 662-16-97-51 133z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m973 811-48 5-4 8z",
    fill: "#c10d6e",
    stroke: "#c10d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m955 565-94-27 43 160z",
    fill: "#a6086e",
    stroke: "#a6086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m964 110-27-44-82 85z",
    fill: "#b70b6e",
    stroke: "#b70b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959 284-118-11 56 100z",
    fill: "#8c046d",
    stroke: "#8c046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m955 565-12-28-82 1z",
    fill: "#a4086e",
    stroke: "#a4086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904 698-43-160-38 174z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m937 66-106-28 24 113z",
    fill: "#bc0c6e",
    stroke: "#bc0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m861 538-53 5 15 169z",
    fill: "#f4156e",
    stroke: "#f4156e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m897 373-56-100-21 51z",
    fill: "#9e076e",
    stroke: "#9e076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m921 824-40-57 5 76z",
    fill: "#94056e",
    stroke: "#94056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m925 816-44-49 40 57z",
    fill: "#ff1a6f",
    stroke: "#ff1a6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m921 824-35 19 17 11z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886 843-5-76-32 79z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m903 854-17-11-37 3z",
    fill: "#ff186f",
    stroke: "#ff186f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904 698-81 14 58 55z",
    fill: "#bf0d6e",
    stroke: "#bf0d6e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#86036d",
    stroke: "#86036d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m871-79-103 56 63 61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m897 373-77-49 26 78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m831 38-63-61 1 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m846 402-23 11-7 48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m881 767-96 59 64 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855 151-118 84 104 38z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m881 767-58-55-38 114z",
    fill: "#b80b6e",
    stroke: "#b80b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823 712-15-169-105 111z",
    fill: "#a0076e",
    stroke: "#a0076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m849 846-64-20-64 50z",
    fill: "#98066e",
    stroke: "#98066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855 151-24-113-78 51z",
    fill: "#8b046d",
    stroke: "#8b046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m861 538-45-77-8 82z",
    fill: "#ba0c6e",
    stroke: "#ba0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m871-79-104-2 1 58z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m816 461-33 30 25 52z",
    fill: "#cf0f6e",
    stroke: "#cf0f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m846 402-26-78 3 89z",
    fill: "#ff1b6f",
    stroke: "#ff1b6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855 151-102-62-16 146z",
    fill: "#a4086e",
    stroke: "#a4086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823 413-3-89-32 1z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m841 273-104-38 27 54z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m753 89-64 66 48 80z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m820 324-56-35 24 36z",
    fill: "#ad0a6e",
    stroke: "#ad0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m841 273-77 16 56 35z",
    fill: "#99066e",
    stroke: "#99066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m831 38-62-52-44 54z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m831 38-106 2 28 49z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823 712-120-58 82 172z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823 413-35-88-120 47z",
    fill: "#a4086e",
    stroke: "#a4086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823 413-40 78 33-30z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823 413-155-41 115 119z",
    fill: "#95066e",
    stroke: "#95066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m783 491-115-119-21 72z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m808 543-25-52-161 83z",
    fill: "#aa096e",
    stroke: "#aa096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m808 543-186 31 81 80z",
    fill: "#92056e",
    stroke: "#92056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m710 876-7-222-40 222z",
    fill: "#8c046d",
    stroke: "#8c046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m753 89-46 10-18 56z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m783 491-136-47-25 130z",
    fill: "#9c076e",
    stroke: "#9c076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785 826-75 50h5z",
    fill: "#b60b6e",
    stroke: "#b60b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785 826-82-172 7 222z",
    fill: "#92056e",
    stroke: "#92056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788 325-24-36-96 83z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m721-81h-179l4 2z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785 826-70 50h6z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m663 876-53-211-53 68z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m703 654-93 11 53 211z",
    fill: "#ae0a6e",
    stroke: "#ae0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m707 99-20 42 2 14z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768-23-1-58h-46z",
    fill: "#a6086e",
    stroke: "#a6086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m769-14-1-9-43 63z",
    fill: "#ae0a6e",
    stroke: "#ae0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768-23-107-16 64 79z",
    fill: "#aa096e",
    stroke: "#aa096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768-23-47-58-60 42z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m764 289-27-54-93 14z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m764 289-120-40 24 123z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m737 235-48-80-17 59z",
    fill: "#8a046d",
    stroke: "#8a046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m753 89-28-49-18 59z",
    fill: "#c60e6e",
    stroke: "#c60e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668 372-24-123-24 82z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m721-81-175 2 115 40z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m737 235-65-21-28 35z",
    fill: "#9b076e",
    stroke: "#9b076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m725 40-66 18 48 41z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m725 40-64-79-2 97z",
    fill: "#a3086e",
    stroke: "#a3086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661-39-26 16 24 81z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m703 654-81-80-12 91z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525-81h-226l179 15z",
    fill: "#c50e6e",
    stroke: "#c50e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m707 99-48-41 28 83z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m663 876-106-143-26 34z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m687 141-28-83-90 15z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m689 155-2-14-140-4z",
    fill: "#a2086e",
    stroke: "#a2086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m689 155-142-18 125 77z",
    fill: "#a3086e",
    stroke: "#a3086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m687 141-118-68-22 64z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647 444-90 22 65 108z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m661-39-115-40 89 56z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668 372-108 39 87 33z",
    fill: "#b20a6e",
    stroke: "#b20a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m672 214-125-77 97 112z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668 372-48-41-60 80z",
    fill: "#8b046d",
    stroke: "#8b046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569 73-23 38 1 26z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659 58-24-81-66 96z",
    fill: "#8a046d",
    stroke: "#8a046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m663 876-132-109-39 44z",
    fill: "#8c046d",
    stroke: "#8c046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m663 876-171-65-9 65z",
    fill: "#96066e",
    stroke: "#96066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m644 249-137 42 113 40z",
    fill: "#97066e",
    stroke: "#97066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m644 249-97-112-40 154z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647 444-87-33-3 55z",
    fill: "#8d046d",
    stroke: "#8d046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622 574-65-108-41 83z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635-23-89-56 23 152z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569 73-23-152-74 106z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622 574-106-25 94 116z",
    fill: "#be0c6e",
    stroke: "#be0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m620 331-113-40 53 120z",
    fill: "#96066e",
    stroke: "#96066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m547 137-51 10 11 144z",
    fill: "#ef156e",
    stroke: "#ef156e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610 665-73 72 20-4z",
    fill: "#99066e",
    stroke: "#99066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610 665-94-116 21 188z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525-81-47 15-6 93z",
    fill: "#e4136e",
    stroke: "#e4136e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m537 737-21-188-145 210z",
    fill: "#94056e",
    stroke: "#94056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546-79-21-2-53 108z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557 466-50 14 9 69z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557 733-20 4-6 30z",
    fill: "#8a046d",
    stroke: "#8a046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560 411-90-117-44 35z",
    fill: "#9a066e",
    stroke: "#9a066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560 411-134-82 4 87z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560 411-53-120-37 3z",
    fill: "#ab096e",
    stroke: "#ab096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569 73-97-46 74 84z",
    fill: "#a1086e",
    stroke: "#a1086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478-66-179-15 58 29z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m516 549-189 30 44 180z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531 767-37 27-2 17z",
    fill: "#f6166e",
    stroke: "#f6166e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560 411-53 69 50-14z",
    fill: "#cf0f6e",
    stroke: "#cf0f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560 411-130 5 77 64z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 147-80 109 54 38z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507 291-11-144-26 147z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546 111-74-84 24 120z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546-79-4-2h-17z",
    fill: "#f9166f",
    stroke: "#f9166f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m547 137-1-26-50 36z",
    fill: "#f5166e",
    stroke: "#f5166e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m537 737-43 57 37-27z",
    fill: "#f1156e",
    stroke: "#f1156e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m537 737-166 22 123 35z",
    fill: "#9c076e",
    stroke: "#9c076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 147-24-120-62 64z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 147-110 78 30 31z",
    fill: "#96066e",
    stroke: "#96066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507 480-77-64v66z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m516 549-9-69-77 2z",
    fill: "#95066e",
    stroke: "#95066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m516 549-86-67-103 97z",
    fill: "#8f056e",
    stroke: "#8f056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 256-30-31 14 20z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492 811-48 65h39z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494 794-123-35 2 23z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 147-86-56-43 70z",
    fill: "#a6086e",
    stroke: "#a6086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 147-129 14 19 64z",
    fill: "#97066e",
    stroke: "#97066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494 794-121-12 119 29z",
    fill: "#8c046d",
    stroke: "#8c046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478-66-121 14 115 79z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492 811-119-29 71 94z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 91-10-44 5 38z",
    fill: "#ff1e6f",
    stroke: "#ff1e6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472 27-115-79 43 99z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472 27-72 20 10 44z",
    fill: "#b90c6e",
    stroke: "#b90c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470 294-54-38 10 73z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327 579-45 126 23 30z",
    fill: "#c20d6e",
    stroke: "#c20d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371 759-44-180-22 156z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430 482-95 13-8 84z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430 482v-66l-47 34z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444 876-125-42-51 38z",
    fill: "#94056e",
    stroke: "#94056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444 876-114-53-11 11z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444 876-71-94-43 41z",
    fill: "#94056e",
    stroke: "#94056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 329-10-73-16-11z",
    fill: "#c00d6e",
    stroke: "#c00d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 329-26-84-100 70z",
    fill: "#c00d6e",
    stroke: "#c00d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426 329-126-14 83 135z",
    fill: "#a7096e",
    stroke: "#a7096e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#86036d",
    stroke: "#86036d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m430 416-4-87-43 121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430 482-47-32-48 45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405 85-5-38-16 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 91-54-3 11 73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 245-108 16 8 54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 91-5-6-49 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 47-132-15 116 36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 47-43-99-89 84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405 85-21-17-28 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 245-14-20-94 36z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m384 68-116-36 88 56z",
    fill: "#a6086e",
    stroke: "#a6086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357-52-91 34 2 50z",
    fill: "#a7096e",
    stroke: "#a7096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367 161-77-5 2 105z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367 161-11-73-36 31z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 450-167-10 119 55z",
    fill: "#93056e",
    stroke: "#93056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 450-83-135-84 125z",
    fill: "#99066e",
    stroke: "#99066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386 225-19-64-75 100z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292 261-2-105-25 26z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327 579-37 4-8 122z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367 161-47-42-6 18z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373 782-2-23-66-24z",
    fill: "#dc116e",
    stroke: "#dc116e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373 782-68-47 25 88z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367 161-53-24-24 19z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356 88-88-56 52 87z",
    fill: "#c20d6e",
    stroke: "#c20d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357-52-58-29-33 63z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 315-8-54-6 37z",
    fill: "#d5106e",
    stroke: "#d5106e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 315-105 47 21 78z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 823-25-88 14 99z",
    fill: "#ff206f",
    stroke: "#ff206f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335 495-45 88 37-4z",
    fill: "#ee146e",
    stroke: "#ee146e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335 495-116 23 71 65z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335 495-119-55 3 78z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319 834-14-99-83-14z",
    fill: "#ae0a6e",
    stroke: "#ae0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 119-52-87-30 80z",
    fill: "#98066e",
    stroke: "#98066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319 834-97-113 46 151z",
    fill: "#9e076e",
    stroke: "#9e076e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#86036d",
    stroke: "#86036d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290 583-104 47 96 75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292 261-27-79-26 52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 119-82-7 76 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 872-46-151-58 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314 137-76-25 52 44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 315-14-17-91 64z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m305 735-23-30-60 16z",
    fill: "#ab096e",
    stroke: "#ab096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299-81-182 3 149 60z",
    fill: "#ab096e",
    stroke: "#ab096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282 705-96-75 36 91z",
    fill: "#92056e",
    stroke: "#92056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292 261-53-27 47 64z",
    fill: "#bf0d6e",
    stroke: "#bf0d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290 156-52-44 27 70z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290 583-71-65-33 112z",
    fill: "#9a066e",
    stroke: "#9a066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 298-47-64-44 128z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 182-27-70-70 49z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266-18-149-60 32 97z",
    fill: "#9b076e",
    stroke: "#9b076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 32-93 62 63 18z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 32-2-50-117 37z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 32-119-13 26 75z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 872-104-100-94 84z",
    fill: "#8d046d",
    stroke: "#8d046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 872-198-16-2 20z",
    fill: "#a5086e",
    stroke: "#a5086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 182-97-21 71 73z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219 518-68 89 35 23z",
    fill: "#8c046d",
    stroke: "#8c046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 112-63-18-7 67z",
    fill: "#93056e",
    stroke: "#93056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239 234-72-18 28 146z",
    fill: "#c20d6e",
    stroke: "#c20d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239 234-71-73-1 55z",
    fill: "#92056e",
    stroke: "#92056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175 94-26-75-10 24z",
    fill: "#d1106e",
    stroke: "#d1106e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195 362-28-146-67 123z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 440-21-78-38 64z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219 518-112 52 44 37z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219 518-3-78-59-14z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219 518-62-92-37 16z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 721-100-10 42 61z",
    fill: "#9b076e",
    stroke: "#9b076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 721-36-91-65 61z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 721-101-30 1 20z",
    fill: "#ae0a6e",
    stroke: "#ae0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219 518-99-76-13 128z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117-78-260-3 176 41z",
    fill: "#9c076e",
    stroke: "#9c076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164 772-42-61 6 47z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167 216-95 99 28 24z",
    fill: "#a5086e",
    stroke: "#a5086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195 362-71 26 33 38z",
    fill: "#9a066e",
    stroke: "#9a066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195 362-80 5 9 21z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195 362-95-23 15 28z",
    fill: "#b90c6e",
    stroke: "#b90c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 442-32 119 19 9z",
    fill: "#e6136e",
    stroke: "#e6136e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164 772-36-14-58 98z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167 216-112 54 17 45z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186 630-35-23-30 84z",
    fill: "#b80b6e",
    stroke: "#b80b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175 94-36-51-64 15z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175 94-128 35 121 32z",
    fill: "#aa096e",
    stroke: "#aa096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175 94-100-36-28 71z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 758-74 40 16 58z",
    fill: "#87036d",
    stroke: "#87036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167 216-120-87 8 141z",
    fill: "#92056e",
    stroke: "#92056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 161-121-32 120 87z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 758-47 3-27 37z",
    fill: "#8a046d",
    stroke: "#8a046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149 19-32-97-84 38z",
    fill: "#94056e",
    stroke: "#94056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 607-44-37 14 121z",
    fill: "#a4086e",
    stroke: "#a4086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157 426-33-38-4 54z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149 19-116-59 42 98z",
    fill: "#95066e",
    stroke: "#95066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68 876-105-32-106 32z",
    fill: "#8e046e",
    stroke: "#8e046e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121 691-14-121-91 103z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149 19-74 39 64-15z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107 570-91 18v85z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 58-42-98 7 88z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107 570-19-9-72 27z",
    fill: "#cd0f6e",
    stroke: "#cd0f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 442-99-48 67 167z",
    fill: "#8d046d",
    stroke: "#8d046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121 691-105-18 45 43z",
    fill: "#ac096e",
    stroke: "#ac096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124 388-103 6 99 48z",
    fill: "#ab096e",
    stroke: "#ab096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 758-6-47-38 39z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 758-44-8-3 11z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124 388-9-21-94 27z",
    fill: "#c40d6e",
    stroke: "#c40d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122 711-1-20-60 25z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122 711-61 5 23 34z",
    fill: "#92056e",
    stroke: "#92056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 270-8-141-66 43z",
    fill: "#99066e",
    stroke: "#99066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 561-67-167-5 194z",
    fill: "#8d046d",
    stroke: "#8d046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115 367-15-28-79 55z",
    fill: "#b40b6e",
    stroke: "#b40b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84 750-23-34v16z",
    fill: "#ed146e",
    stroke: "#ed146e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100 339-28-24-51 79z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 315-38-3-13 82z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 48-7-88-33 59z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 58-35-10 7 81z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84 750-23-18 20 29z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81 761-20-29-39 33z",
    fill: "#89046d",
    stroke: "#89046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81 761-59 4 32 33z",
    fill: "#a2086e",
    stroke: "#a2086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 270-74-98-1 105z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 315-17-45-21 42z",
    fill: "#8f046e",
    stroke: "#8f046e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 394-164 145 159 49z",
    fill: "#9e076e",
    stroke: "#9e076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 856-16-58-91 46z",
    fill: "#a5086e",
    stroke: "#a5086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 588-29 24 29 61z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 856-107-12 105 32z",
    fill: "#aa096e",
    stroke: "#aa096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 394-164 27v118z",
    fill: "#a7096e",
    stroke: "#a7096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 732v-16l-39 49z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 716-45-43 6 92z",
    fill: "#87036d",
    stroke: "#87036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 129-7-81-77 109z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 798-32-33-59 79z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 270-75 7 33 26z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 270-42 33 21 9z",
    fill: "#ff1e6f",
    stroke: "#ff1e6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 394-8-91-64 40z",
    fill: "#aa096e",
    stroke: "#aa096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 312-21-9 8 91z",
    fill: "#ff196f",
    stroke: "#ff196f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 48-40-29-37 138z",
    fill: "#bd0c6e",
    stroke: "#bd0c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 129-84 28 18 15z",
    fill: "#9b076e",
    stroke: "#9b076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 19-105 74 68 64z",
    fill: "#9d076e",
    stroke: "#9d076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 765-6-92-75 40z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 588-159-49 130 73z",
    fill: "#97066e",
    stroke: "#97066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 765-81-52 1 42z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33-40-176-41 143 100z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 394-72-51-92 78z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 765-91 49 32 30z",
    fill: "#90056e",
    stroke: "#90056e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 765-80-10-11 59z",
    fill: "#99066e",
    stroke: "#99066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 19-143-100v99z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 673-29-61-46 101z",
    fill: "#a5086e",
    stroke: "#a5086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 303-33-26-31 66z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-20 277-14-113-53 128z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19 172-15-8 14 113z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 19-143-1 38 75z",
    fill: "#a2086e",
    stroke: "#a2086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-51 343-92 55v23z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-34 164-109 43 56 85z",
    fill: "#8c046d",
    stroke: "#8c046d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-20 277-67 15 36 51z",
    fill: "#a3086e",
    stroke: "#a3086e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19 172-18-15 3 7z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-13 612-130-73 84 174z",
    fill: "#ad0a6e",
    stroke: "#ad0a6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-37 157-106-8v58z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-37 844-32-30-74 62z",
    fill: "#95066e",
    stroke: "#95066e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-34 164-3-7-106 50z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-37 157-68-64-38 56z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-59 713-84-174v216z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-69 814-64 4-10 58z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-58 755-55 10 44 49z",
    fill: "#e1126e",
    stroke: "#e1126e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-51 343-48-35-44 52z",
    fill: "#aa096e",
    stroke: "#aa096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-51 343-92 17v38z",
    fill: "#b30b6e",
    stroke: "#b30b6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-51 343-36-51-12 16z",
    fill: "#dc116e",
    stroke: "#dc116e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-58 755-1-42-54 52z",
    fill: "#d7116e",
    stroke: "#d7116e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-59 713-84 42 30 10z",
    fill: "#a8096e",
    stroke: "#a8096e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-69 814-44-49-20 53z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-87 292-56-85 44 101z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-99 308-44-101v153z",
    fill: "#a0076e",
    stroke: "#a0076e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-105 93-38-75v131z",
    fill: "#86036d",
    stroke: "#86036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-113 765-30-10 10 63z",
    fill: "#88036d",
    stroke: "#88036d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-133 818-10-63v121z",
    fill: "#ff206f",
    stroke: "#ff206f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.44a6a78a53982ce4536fa3ade7cbb115.svg";
export { ForwardRef as ReactComponent };